module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "image",
    attrs: {
      "id": "fig_2.1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "title": "30"
    }
  }, [_c('a', {
    attrs: {
      "id": "fig_30"
    }
  }), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "alt": "",
      "src": "images/f030-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('b', [_vm._v("Fig. 2.1.")]), _vm._v(" A speculative reconstruction of "), _c('i', [_vm._v("Weichselia reticulata")]), _vm._v(". Artwork by Joschua Knüppe.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f612163","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter02.vue
// module id = 99
// module chunks = 0